import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f9b9d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-client-type-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_order_header_change_actions = _resolveComponent("order-header-change-actions")!
  const _component_select_price_type_component = _resolveComponent("select-price-type-component")!
  const _component_back_and_cancel_footer = _resolveComponent("back-and-cancel-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.$t('cashier.header.select-price-type')
    }, null, 8, ["text"]),
    _createVNode(_component_order_header_change_actions, { selected: 1 }),
    _createVNode(_component_select_price_type_component),
    _createVNode(_component_back_and_cancel_footer)
  ]))
}